import { activititesQueries } from '../queries/queries'

const redeemYZValidation = ({
  payment_method_id,
  code,
  success = () => {},
  error = () => {}
}) => ({
  type: 'API:REDEEM:YOUZAN:CODE:VALIDATION',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.MUTATION_REDEEM_YOUZAN_CODE,
    variables: { input: { payment_method_id, code, raise_redeem_error: false } }
  },
  success,
  error
})

const queryWechatSubscribeConfig = (advisor_type, success, error) => ({
  type: 'API:WECHAT_SUBSCRIBE_MESSAGE_CONFIG',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.QUERY_WECHAT_SUBSCRIBE_MESSAGE_CONFIG,
    variables: { advisor_type }
  },
  success,
  error
})

const queryLotteryActivity = (
  customer_id,
  lottery_activity_type,
  success,
  error
) => ({
  type: 'API:LOTTERY_ACTIVITY',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.QUERY_LOTTERY_ACTIVITY,
    variables: { customer_id, lottery_activity_type }
  },
  success,
  error
})

const grantExchangeCard = (input, success, error) => ({
  type: 'API:GRANT_EXCHANGE_CARD',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.MUTATION_GRANT_EXCHANGE_CARD,
    variables: { input }
  },
  success,
  error
})

const queryLotteryWinList = (customer_id, success, error) => ({
  type: 'API:LOTTERY_WIN_LIST',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.QUERY_LOTTERY_WIN_LIST,
    variables: { customer_id }
  },
  success,
  error
})

const lottery = (customer_id, lottery_activity_id, success, error) => ({
  type: 'API:MUTATION_CUSTOMER_LOTTERY',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.MUTATION_CUSTOMER_LOTTERY,
    variables: { input: { customer_id, lottery_activity_id } }
  },
  success,
  error
})

const queryCommonActivity = (common_activity_type, success, error) => ({
  type: 'API:COMMON_ACTIVITY',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.QUERY_COMMON_ACTIVITY,
    variables: { common_activity_type }
  },
  success,
  error
})

const updateCustomerCommonActivity = (input, success, error) => ({
  type: 'API:MUTATION_CUSTOMER_COMMON_ACTIVITY',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: activititesQueries.MUTATION_CUSTOMER_COMMON_ACTIVITY,
    variables: { input }
  },
  success,
  error
})

export default {
  redeemYZValidation,
  queryLotteryActivity,
  queryLotteryWinList,
  lottery,
  queryCommonActivity,
  updateCustomerCommonActivity,
  queryWechatSubscribeConfig,
  grantExchangeCard
}
